
  <div class="row mb-2  " >
    <div class="col-md-6">
      <div> <input type="search" (ngModelChange)="applyFilter($event)" [(ngModel)]="searchText" class="form-control " placeholder="Search by business name " style="width: 70%"> </div>
    </div>
      <div class="col-md-6 m-0 text-end">
        <button (click)="exportToExcel()" style="margin-right:5px !important" class="btn-shadow  d-inline-flex align-items-center btn btn-success"><i class="fa fa-file-excel-o" aria-hidden="true"></i>
           Export Current Excel  </button>
           <button  class="btn-shadow d-inline-flex align-items-center btn btn-success"><i class="fa fa-file-excel-o" aria-hidden="true"></i>
            Export All Excel </button>
      </div>
   
    
  </div>
  

      <div class="main-card mb-3 card">
        <div class="card-header">
          All Business
        </div>
        <div class="table-responsive">
          <table class="align-middle mb-0 table table-borderless table-striped table-hover"  id="excel-table">
            <thead>
            <tr>
              <!-- <th class="text-left" >#</th> -->
              <th> Name</th>
              <th class="text-end">Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let data of allBusinessList | paginate : { itemsPerPage: itemsPerPage, currentPage: page, totalItems: totalItems  }">
              <!-- <td class="text-left text-muted">#345</td> -->
              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">{{data.name}}</div>
                      <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                    </div>
                  </div>
                </div>
              </td>
             
              <td class="text-end">
                <div class="dropdown">
                  <button class="btn btn-info dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                    Action
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                    <li><a class="dropdown-item" href="#">Delete <i class="fa fa-trash"></i></a></li>
                  </ul>
                </div>
              </td>
            </tr>
           
            </tbody>
            <div *ngIf="allBusinessList?.length  == 0" class="text-center mt-5 mb-5" >
              <span class="text-danger">Data Not found</span>
            </div>
            <pagination-controls class="my-pagination" (pageChange)="gty((page = $event))"></pagination-controls>
            
          </table>
        </div>
      </div>



